









import Vue from 'vue';
import moment from 'moment';
import config from '../../../config';
import CookieHelper from '../../helpers/OldCookieHelper';
import DomEventHelper from '../../helpers/DomEventHelper';
import OldFormatHelper from '../../helpers/OldFormatHelper';

interface ILimitingShoppingTimeDisplayComponent {
  timeLeft: string;
  timeLeftInterval: number | null;
}

export default Vue.extend({
  data(): ILimitingShoppingTimeDisplayComponent {
    return {
      timeLeft: `00:00`,
      timeLeftInterval: null,
    };
  },
  mounted(): void {
    /*
     * Date.now() fallback for users that completed a shopping window
     * and add a product to the cart without reloading
     * no cookie exists and we wouldn't have a startTime
     */
    let startTime = Date.now();

    const bouncerStartTimeCookie = CookieHelper.getBouncerShoppingStartTime();
    if(bouncerStartTimeCookie) {
      startTime = parseInt(bouncerStartTimeCookie, 10);
    }

    const endTime = moment(startTime).add(config.bouncer.config.endTimeOffsetInMinutes, `m`).toDate();
    this.calculateTimeLeft(endTime);
    this.timeLeftInterval = window.setInterval(() => {
      this.calculateTimeLeft(endTime);
    }, 1000);
  },
  beforeDestroy(): void {
    if(this.timeLeftInterval) {
      window.clearInterval(this.timeLeftInterval);
    }
  },
  methods: {
    calculateTimeLeft(endTime: Date): void {
      const now = Date.now();
      const distance = +endTime - now; // https://github.com/microsoft/TypeScript/issues/5710#issuecomment-157886246

      if(distance <= 0) {
        if(this.timeLeftInterval) {
          window.clearInterval(this.timeLeftInterval);
        }
        DomEventHelper.fireEvent({ name: `rin-limiting-time-is-up` });
        return;
      }

      this.timeLeft = `${OldFormatHelper.formatTimeValue(distance, `minute`)}:${OldFormatHelper.formatTimeValue(distance, `second`)}`;
    },
  },
});
